import { Button, Center } from "@chakra-ui/react";
import React, { useState } from "react";
import { BsPlusCircle } from "react-icons/bs";
import ButtonWithModalPopup from "../../shared/components/ButtonWithModalPopup/ButtonWithModalPopup";
import ListOrEmpty from "../../shared/components/ListOrEmpty/ListOrEmpty";
import { ViewWrapper } from "../../shared/components/ViewWrapper/ViewWrapper";
import { buttonBg } from "../../shared/constants/views.constant";

export const StackPage = () => {
  const [isEmployeeFormVisibile, setIsEmployeeFormVisibile] =
    useState<boolean>(false);
  return (
    <ViewWrapper>
      <ButtonWithModalPopup
        isOpen={isEmployeeFormVisibile}
        onClose={() => setIsEmployeeFormVisibile(false)}
        mv={1}
        btnComponent={() => (
          <Button
            bg={buttonBg}
            borderRadius="25px"
            onClick={() => setIsEmployeeFormVisibile(true)}
            colorScheme="purple"
          >
            <BsPlusCircle />
            &nbsp; Create a new stack
          </Button>
        )}
        title="Add a new Stack"
      ></ButtonWithModalPopup>
      <Center height="50vh">
        <ListOrEmpty listName={"Stacks"} list={[]} />
      </Center>
    </ViewWrapper>
  );
};
